<div class="card bg-transparent border-0 shadow mt-3 p-4">
    <div class="chart-container">
        <canvas baseChart #myCanvas
            [datasets]="lineChartData" 
            [labels]="lineChartLabels" 
            [options]="lineChartOptions"
            [type]="'line'">
        </canvas>
    </div>
</div>

<div class="card bg-transparent border-0 shadow mt-3 p-3" style="min-height: 38vh;max-height: 38vh; overflow-y: scroll;" tabindex="0" role="region" aria-label="Notifications panel">
    <app-notifications></app-notifications>
</div>

<!-- <hr> -->
